import { render, staticRenderFns } from "./CoachCreateResume.vue?vue&type=template&id=0a9209d8&"
import script from "./CoachCreateResume.vue?vue&type=script&lang=ts&"
export * from "./CoachCreateResume.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports